import * as React from "react";
import { displayErrorToast } from "src/components/shared/Toasts/Toast";
import {
  ApproveChangesIcon,
  EditTaskPanelWrapper,
  EditTaskTextArea,
} from "src/components/TaskListPanel/TaskList/TaskListItem/EditTaskPanel/EditTaskPanel.components";
import { ToastIds } from "src/enums/errorToastIds";
import { useGameContext } from "src/game/useGameContext";

export interface Props {
  taskId: string;
  title: string;
  toggleEditPanel: (isDeleting: boolean, taskKey?: string) => void;
}

export const EditTaskPanel: React.FunctionComponent<Props> = ({
  taskId,
  title,
  toggleEditPanel,
}) => {
  const { gameState, actionHandlers } = useGameContext();

  const [titleText, setTitleText] = React.useState(title);

  const handleUpdateTask = async () => {
    if (!gameState.game?.id || !gameState.token) {
      return;
    }

    const authData = {
      gameId: gameState.game?.id,
      token: gameState.token,
    };

    try {
      if (titleText == "") {
        displayErrorToast(
          "Task name cannot be empty",
          ToastIds.TASK_UPDATE_FAILED
        );
        return;
      }

      const response = await actionHandlers.updateTask({
        taskId: taskId,
        ...authData,
        task: {
          description: titleText,
        },
      });
      if (response.error) {
        displayErrorToast(
          `Failed to update task ${response.error.message}`,
          ToastIds.TASK_UPDATE_FAILED
        );
      } else {
        toggleEditPanel(false);
      }
    } catch (e) {
      displayErrorToast("Failed to update task", ToastIds.TASK_UPDATE_FAILED);
    }
  };

  return (
    <EditTaskPanelWrapper>
      <EditTaskTextArea
        value={titleText}
        onChange={e => {
          setTitleText(e.target.value);
        }}
      />
      <ApproveChangesIcon
        data-testid="saveTaskChangesIcon"
        onClick={handleUpdateTask}
      />
    </EditTaskPanelWrapper>
  );
};

export default EditTaskPanel;
